export type TranslationScope = "grid" | "menu" | "eform" | "service" | "general";

export interface TranslationEntry {
  module: string;
  field: string;
  scope?: TranslationScope;
  lang: string;
  label: string;
}

export interface TranslationLookupArgs {
  module: string;
  field: string;
  lang: string;
  scope?: TranslationScope;
  fallback?: string;
}

export default class TranslationResolver {
  private entries: TranslationEntry[];

  constructor(entries: TranslationEntry[] = []) {
    this.entries = entries;
  }

  public setEntries(entries: TranslationEntry[]) {
    this.entries = entries || [];
  }

  public addEntries(entries: TranslationEntry[]) {
    this.entries = [...this.entries, ...(entries || [])];
  }

  public translate(args: TranslationLookupArgs): string {
    const { module, field, lang, scope, fallback } = args;

    const exact = this.entries.find(
      (e) =>
        e.module === module &&
        e.field === field &&
        e.lang === lang &&
        (scope ? e.scope === scope : true)
    );

    if (exact?.label) return exact.label;

    const scopeAgnostic = this.entries.find(
      (e) =>
        e.module === module &&
        e.field === field &&
        e.lang === lang
    );

    if (scopeAgnostic?.label) return scopeAgnostic.label;

    return fallback || field;
  }
}
